var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-echart-bar',{staticClass:"trend-chart",attrs:{"option-data":_vm.option}})}
var staticRenderFns = []

export { render, staticRenderFns }